import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makePaymentWithoutOfficialBill } from 'redux/payments/payments.actions';
import { UserInfoModal } from 'components';
import { needToCheckUserInfoForcedFields } from 'utils/validation';

const mapState = (state) => ({
  profile: state.userData.profile,
  isOfficialBillNeeded: state.paymentsData.isOfficialBillNeeded,
  selectedPackage: state.paymentsData.selectedPackage,
  selectedPackageType: state.paymentsData.selectedPackageType,
  selectedDuration: state.paymentsData.selectedDuration,
  discountCode: state.paymentsData.discountCode,
  useCredit: state.paymentsData.useCredit,
  invoiceId: state.paymentsData.invoiceId,
  selectedConversationCount: state.paymentsData.selectedConversationCount,
  payablePrice: state.paymentsData.payablePrice,
  paymentInfo: state.paymentsData.paymentInfo,
  locale: state.appData.locale,
});

function GetInfoFromUser({
  isPackageUpgrade,
  visible,
  toggle,
  checkBeforePurchaseStatus,
  setCheckBeforePurchaseStatus,
}) {
  const dispatch = useDispatch();
  const {
    profile,
    isOfficialBillNeeded,
    selectedPackage,
    selectedPackageType,
    selectedDuration,
    discountCode,
    useCredit,
    // invoiceId,
    selectedConversationCount,
    payablePrice,
    paymentInfo,
    // locale,
  } = useSelector(mapState);

  const checkForBeforePurchaseParameter = () => {
    const needCheck = needToCheckUserInfoForcedFields(
      paymentInfo.data,
      profile.mobile
    );

    setCheckBeforePurchaseStatus(needCheck);
  };

  const handleMakePaymentWithoutOfficialBill = () => {
    const invoiceDataForFaLocale = isPackageUpgrade
      ? {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedPackage,
          selectedDuration,
          discountCode,
          useCredit,
          payablePrice,
          selectedPackageType,
        }
      : {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedConversationCount,
          payablePrice,
        };

    // const invoiceDataForEngLocale = {
    //   selectedPackageType,
    //   isPackageUpgrade,
    //   selectedDuration,
    //   discountCode,
    //   useCredit,
    //   selectedConversationCount,
    // };

    // if (locale === 'en') {
    //   dispatch(makePaymentWithoutOfficialBillEng(invoiceDataForEngLocale));
    //   return;
    // }

    dispatch(makePaymentWithoutOfficialBill({ ...invoiceDataForFaLocale }));
  };

  useEffect(() => {
    checkForBeforePurchaseParameter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentInfo]);

  return (
    <UserInfoModal
      visible={visible}
      handleClose={toggle}
      doAfterSuccessfullUpdate={handleMakePaymentWithoutOfficialBill}
    />
  );
}

export default GetInfoFromUser;
